module.exports = __webpack_public_path__ + "static/media/star-spot.a89a86c5.svg";